import React, { useState } from "react";
import { Tabs, Tab, Row, Col, Card, Badge, Button, Modal } from "react-bootstrap";
import {
  FaInfoCircle,
  FaUsers,
  FaRegClock,
  FaMapMarkerAlt,
  FaCreditCard,
  FaCommentDots,
  FaHistory,
  FaPhone,
  FaEnvelope,
  FaImages,
} from "react-icons/fa";
import Timeline from "../special-pages/timeline";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { cancelJobByAdmin } from "../../../services/service";
import { toast } from "react-toastify";
// SAFE BILINGUAL TEXT – ALWAYS RETURNS STRING
const getBilingualText = (obj, field) => {
  try {
    if (!obj || typeof obj !== "object") return "N/A";

    const value = obj[field];
    if (!value) return "N/A";

    if (typeof value === "string") return value.trim() || "N/A";
    if (typeof value === "object") {
      const en = value.en?.trim?.() || "";
      const hi = value.hi?.trim?.() || "";
      if (en && hi) return `${en} (${hi})`;
      return en || hi || "N/A";
    }

    return value.toString?.() || "N/A";
  } catch {
    return "N/A";
  }
};

export default function JobDetail({ job = {}, onRefresh }) {
  const paymentStatusVariant =
    job.paymentStatus === "Pending" ? "warning" : "success";
  const reviewStatusVariant =
    job.reviewStatus === "Pending" ? "secondary" : "success";
  const extensionRequested = job.extensions && job.extensions.length > 0;
  const commissionType = localStorage.getItem("commissionType");
  const commissionValue = parseFloat(localStorage.getItem("commissionValue"));
  // -------------------------
  // Date utilities - FIXED: FORCE IST EVEN IF API SENDS UTC
  // -------------------------
  // const TIMEZONE = 'Asia/Kolkata';

  // const parseDateFlexible = (input) => {
  //   if (!input && input !== 0) return null;
  //   if (input instanceof Date) return isNaN(input.getTime()) ? null : input;

  //   if (typeof input === "number") {
  //     const d = new Date(input);
  //     return isNaN(d.getTime()) ? null : d;
  //   }

  //   if (typeof input === "string") {
  //     let s = input.trim();

  //     // KEY FIX: Remove 'Z' and force +05:30 (IST) if it has Z
  //     if (s.endsWith('Z')) {
  //       s = s.slice(0, -1) + '+05:30'; // Convert UTC to IST
  //     }

  //     let d = new Date(s);
  //     if (!isNaN(d.getTime())) return d;

  //     const sT = s.replace(" ", "T");
  //     d = new Date(sT);
  //     if (!isNaN(d.getTime())) return d;

  //     const n = Number(s);
  //     if (!Number.isNaN(n)) {
  //       d = new Date(n);
  //       if (!isNaN(d.getTime())) return d;
  //     }

  //     const dmy = s.match(
  //       /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})(?:[ T](\d{2}:\d{2}(?::\d{2})?)?)?$/i
  //     );
  //     if (dmy) {
  //       let [, dd, mm, yy, t] = dmy;
  //       if (yy.length === 2) yy = `20${yy}`;
  //       const timePart = t ? "T" + t : "T00:00:00";
  //       d = new Date(
  //         `${yy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(
  //           2,
  //           "0"
  //         )}${timePart}`
  //       );
  //       if (!isNaN(d.getTime())) return d;
  //     }

  //     const dmy12 = s.match(
  //       /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})[ T](\d{1,2}):(\d{2})(?:\s?(AM|PM))$/i
  //     );
  //     if (dmy12) {
  //       let [, dd, mm, yy, hh, min, ap] = dmy12;
  //       if (yy.length === 2) yy = `20${yy}`;
  //       hh = parseInt(hh, 10);
  //       if (ap?.toUpperCase() === "PM" && hh < 12) hh += 12;
  //       if (ap?.toUpperCase() === "AM" && hh === 12) hh = 0;
  //       d = new Date(
  //         `${yy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(
  //           2,
  //           "0"
  //         )}T${String(hh).padStart(2, "0")}:${min}:00`
  //       );
  //       if (!isNaN(d.getTime())) return d;
  //     }
  //   }

  //   return null;
  // };

  // const formatDate = (input) => {
  //   const d = parseDateFlexible(input);
  //   if (!d) return '';
  //   return d.toLocaleDateString('en-IN', { timeZone: TIMEZONE, day: '2-digit', month: '2-digit', year: 'numeric' });
  // };

  // const formatTime12 = (input) => {
  //   const d = parseDateFlexible(input);
  //   if (!d) return '';
  //   return d.toLocaleTimeString('en-IN', { timeZone: TIMEZONE, hour: '2-digit', minute: '2-digit', hour12: true });
  // };

  // const makeDateTimeString = (input) => {
  //   const date = formatDate(input);
  //   const time = formatTime12(input);
  //   if (date && time) return `${date} • ${time}`;
  //   if (date) return date;
  //   if (time) return time;
  //   return '';
  // };
  const TIMEZONE = "Asia/Kolkata";

  const parseDateFlexible = (input) => {
    if (!input && input !== 0) return null;
    if (input instanceof Date) return isNaN(input.getTime()) ? null : input;

    if (typeof input === "number") {
      const d = new Date(input);
      return isNaN(d.getTime()) ? null : d;
    }

    if (typeof input === "string") {
      let s = input.trim();
      let d = new Date(s);
      if (!isNaN(d.getTime())) return d;
      const sT = s.replace(" ", "T");
      d = new Date(sT);
      if (!isNaN(d.getTime())) return d;
      const n = Number(s);
      if (!Number.isNaN(n)) {
        d = new Date(n);
        if (!isNaN(d.getTime())) return d;
      }
      const dmy = s.match(
        /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})(?:[ T](\d{2}:\d{2}(?::\d{2})?)?)?$/i
      );
      if (dmy) {
        let [, dd, mm, yy, t] = dmy;
        if (yy.length === 2) yy = `20${yy}`;
        const timePart = t ? "T" + t : "T00:00:00";
        d = new Date(
          `${yy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}${timePart}Z`
        );
        if (!isNaN(d.getTime())) return d;
      }
      const dmy12 = s.match(
        /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})[ T](\d{1,2}):(\d{2})(?:\s?(AM|PM))$/i
      );
      if (dmy12) {
        let [, dd, mm, yy, hh, min, ap] = dmy12;
        if (yy.length === 2) yy = `20${yy}`;
        hh = parseInt(hh, 10);
        if (ap?.toUpperCase() === "PM" && hh < 12) hh += 12;
        if (ap?.toUpperCase() === "AM" && hh === 12) hh = 0;
        d = new Date(
          `${yy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T${hh}:${min}:00Z`
        );
        if (!isNaN(d.getTime())) return d;
      }
    }

    return null;
  };

  const formatDate = (input) => {
    const d = parseDateFlexible(input);
    if (!d) return "";
    return d.toLocaleDateString("en-IN", {
      timeZone: TIMEZONE,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatTime12 = (input) => {
    const d = parseDateFlexible(input);
    if (!d) return "";
    return d.toLocaleTimeString("en-IN", {
      timeZone: TIMEZONE,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const makeDateTimeString = (input) => {
    const date = formatDate(input);
    const time = formatTime12(input);
    if (date && time) return `${date} • ${time}`;
    if (date) return date;
    if (time) return time;
    return "";
  };

  // -------------------------
  // Participants fallback mapping
  // -------------------------
  const customer = job.customerDetails || job.customer || {};
  const vendor = job.vendorDetails || job.vendor || {};

  // -------------------------
  // MAPPING: API → Component (Critical Fix)
  // -------------------------
  const jobStartDateTime = job.startedAt || job.jobStartDateTime;
  const jobEndDateTime = job.endedAt || job.jobEndDateTime;

  // -------------------------
  // Build timeline events with sortTime
  // -------------------------
  /* --------------------------------------------------------------
   TIMELINE – FULLY FIXED & SORTED
   -------------------------------------------------------------- */
  let rawEvents = [];
  /* ---------- 1. Job Booked ---------- */
  if (job?.createdAt) {
    const pd = parseDateFlexible(job.createdAt);
    rawEvents.push({
      dateRaw: job.createdAt,
      sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
      dateStr: makeDateTimeString(job.createdAt),
      title: "Job Created",
      description: `Booked for ${job?.areaTimeValue || ""} ${job?.areaTimeType || ""
        }`,
      status: "primary",
    });
  }

  /* ---------- 2. Vendor Responded ---------- */
  // if (Array.isArray(job?.quote)) {
  //   job.quote.forEach((q, idx) => {
  //     if (q?.respondedAt) {
  //       const pd = parseDateFlexible(q.respondedAt);
  //       rawEvents.push({
  //         dateRaw: q.respondedAt,
  //         sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
  //         dateStr: makeDateTimeString(q.respondedAt),
  //         title: "Vendor Responded",
  //         description: `${getBilingualText(
  //           q.vendor,
  //           "name"
  //         )} responded at ${formatTime12(q.respondedAt)}`,
  //         status: "info",
  //         key: `quote-${idx}`,
  //       });
  //     }
  //   });
  // }

  /* ---------- 3. Vendor Assigned ---------- */
  const assignedAtCandidate =
    job?.quote?.find((q) => q.respondedAt)?.respondedAt ||
    job?.vendor?.assignedAt ||
    job?.assignedAt;

  if (assignedAtCandidate) {
    const pd = parseDateFlexible(assignedAtCandidate);
    rawEvents.push({
      dateRaw: assignedAtCandidate,
      sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
      dateStr: makeDateTimeString(assignedAtCandidate),
      title: "Vendor Accepted",
      description: `Vendor accepted at ${formatTime12(assignedAtCandidate)}`,
      status: "success",
    });
  }

  /* ---------- 4. Job Started ---------- */
  if (jobStartDateTime) {
    const pd = parseDateFlexible(jobStartDateTime);
    rawEvents.push({
      dateRaw: jobStartDateTime,
      sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
      dateStr: makeDateTimeString(jobStartDateTime),
      title: "Job Started",
      description: `job started at ${formatTime12(jobStartDateTime)}`,
      status: "warning",
    });
  }

  /* ---------- 5. Paused / Resumed ---------- */
  if (Array.isArray(job?.activities) && job.activities.length > 0) {
    job.activities.forEach((a) => {
      if (a.type === "pause" && a.pausedAt) {
        const pd = parseDateFlexible(a.pausedAt);
        rawEvents.push({
          dateRaw: a.pausedAt,
          sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(a.pausedAt),
          title: "Job Paused",
          description: `${getBilingualText(a.reason, "en") || "Paused"} ${a.extendedBy ? `(Extended by ${a.extendedBy} mins)` : ""
            }`,
          status: "secondary",
        });
      }

      if (a.type === "resume" && a.resumedAt) {
        const pd = parseDateFlexible(a.resumedAt);
        rawEvents.push({
          dateRaw: a.resumedAt,
          sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(a.resumedAt),
          title: "Job Resumed",
          description: `${a.extendedBy
            ? `Resumed (+${a.extendedBy} mins)`
            : "Job resumed after pause"
            }`,
          status: "info",
        });
      }
    });
  }

  /* ---------- 6. Extensions (all stages) ---------- */
  if (Array.isArray(job?.extensions)) {
    job.extensions.forEach((e) => {
      // REQUESTED
      if (e.createdAt) {
        rawEvents.push({
          dateRaw: e.createdAt,
          sortTime:
            parseDateFlexible(e.createdAt)?.getTime() ||
            Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(e.createdAt),
          title: "Extension Requested",
          description: `By ${getBilingualText(
            e.vendor,
            "name"
          )}: ${getBilingualText(e.reason, "en")}`,
          status: "warning",
        });
      }

      // APPROVED — IMPORTANT: use e.approvedAt, NOT createdAt
      if (e.status === "approved" && e.approvedAt) {
        rawEvents.push({
          dateRaw: e.approvedAt,
          sortTime:
            parseDateFlexible(e.approvedAt)?.getTime() ||
            Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(e.approvedAt),
          title: "Extension Approved",
          description: `Approved at ${formatTime12(e.approvedAt)}`,
          status: "success",
        });
      }

      // REJECTED
      if (e.status === "rejected") {
        const rejectionTime = e.rejectedAt || e.updatedAt;
        if (rejectionTime) {
          rawEvents.push({
            dateRaw: rejectionTime,
            sortTime:
              parseDateFlexible(rejectionTime)?.getTime() ||
              Number.MAX_SAFE_INTEGER,
            dateStr: makeDateTimeString(rejectionTime),
            title: "Extension Rejected",
            description: `Rejected at ${formatTime12(rejectionTime)}`,
            status: "danger",
          });
        }
      }

      // STARTED — ONLY if start exists and not rejected/pending
      if (
        e.extensionStartDateTime !== null &&
        e.status !== "rejected" &&
        e.status !== "pending"
      ) {
        rawEvents.push({
          dateRaw: e.extensionStartDateTime,
          sortTime:
            parseDateFlexible(e.extensionStartDateTime)?.getTime() ||
            Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(e.extensionStartDateTime),
          title: "Extension Started",
          description: `Started at ${formatTime12(e.extensionStartDateTime)}`,
          status: "info",
        });
      }

      // COMPLETED — ONLY if end exists and not rejected/pending
      if (
        e.extensionEndDateTime !== null &&
        e.status !== "rejected" &&
        e.status !== "pending"
      ) {
        rawEvents.push({
          dateRaw: e.extensionEndDateTime,
          sortTime:
            parseDateFlexible(e.extensionEndDateTime)?.getTime() ||
            Number.MAX_SAFE_INTEGER,
          dateStr: makeDateTimeString(e.extensionEndDateTime),
          title: "Extension Completed",
          description: `Completed at ${formatTime12(e.extensionEndDateTime)}`,
          status: "success",
        });
      }
    });
  }

  /* ---------- 7. Job In Progress / Live ---------- */
  if (
    job?.status === "In-progress" &&
    (job?.startedAt || job?.jobStartDateTime)
  ) {
    const start = job.startedAt || job.jobStartDateTime;
    const pd = parseDateFlexible(start);
    rawEvents.push({
      dateRaw: start,
      sortTime: pd ? pd.getTime() + 1 : Number.MAX_SAFE_INTEGER,
      dateStr: "Live",
      title: "Live Job Status",
      description: `Started at ${formatTime12(start)}`,
      status: "warning",
    });
  }

  /* ---------- 8. Job Completed ---------- */
  if (job?.status === "Complete" && (job?.endedAt || job?.jobEndDateTime)) {
    const end = job.endedAt || job.jobEndDateTime;
    const start = job.startedAt || job.jobStartDateTime;
    const pdEnd = parseDateFlexible(end);
    const pdStart = parseDateFlexible(start);
    let endSort = pdEnd ? pdEnd.getTime() : Number.MAX_SAFE_INTEGER;

    if (pdStart && pdEnd && endSort <= pdStart.getTime()) {
      endSort = pdStart.getTime() + 1;
    }

    rawEvents.push({
      dateRaw: end,
      sortTime: endSort,
      priority: 999,
      dateStr: makeDateTimeString(end),
      title: "Job Completed",
      description: `All tasks done at ${formatTime12(end)}`,
      status: "success",
    });
  }

  /* ---------- 9. Job Cancelled ---------- */
  if (job?.status === "Cancelled" && job?.updatedAt) {
    const pd = parseDateFlexible(job.updatedAt);
    rawEvents.push({
      dateRaw: job.updatedAt,
      sortTime: pd ? pd.getTime() : Number.MAX_SAFE_INTEGER,
      dateStr: makeDateTimeString(job.updatedAt),
      title: "Job Cancelled",
      description: "Job was cancelled",
      status: "danger",
    });
  }

  /* ---------- 10. Clean-up & Final Sort ---------- */
  rawEvents = rawEvents.filter(
    (e) => e.dateStr && String(e.dateStr).trim() !== ""
  );
  rawEvents.sort((a, b) => {
    if ((a.priority || 0) !== (b.priority || 0)) {
      return (a.priority || 0) - (b.priority || 0);
    }
    return a.sortTime - b.sortTime;
  });
  const events = rawEvents.map((e) => ({
    date: e.dateStr,
    title: e.title,
    description: e.description,
    status: e.status,
    dateClass: e.dateClass || "text-dark bg-light px-2 rounded",
  }));


  const assignedAt = job?.quote?.find((q) => q.respondedAt)?.respondedAt
    ? makeDateTimeString(job.quote.find((q) => q.respondedAt).respondedAt)
    : vendor?.assignedAt
      ? makeDateTimeString(vendor.assignedAt)
      : "Not Assigned";

  const displayAddress = (addr) => {
    if (!addr) return "—";
    if (typeof addr === "string") return addr;
    return addr.hi ? `${addr.hi} / ${addr.en}` : addr.en || "—";
  };

  const displayMap = (addr) => {
    if (!addr) return "—";
    let address = typeof addr === "string" ? addr : addr.en || "";
    address = address.replace(/\s*\(.*?\)\s*/g, "").trim();
    return address || "—";
  };
  const JOB_STATUS_COLORS = {
    "In-progress": "info",
    Live: "info",
    Pending: "warning",
    Complete: "success",
    Cancelled: "danger",
    paused: "primary",
    extended: "secondary",
    "No-show": "#6f42c1",
    "no-show": "#6f42c1",
    "No Show": "#6f42c1",
    unknown: "secondary",
  };


  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const handleCancelConfirm = async () => {
    setShowCancelModal(false);
    try {
      const jobId = job.id || job._id || job.jobId;
      const res = await cancelJobByAdmin(jobId);
      if (res.success) {
        toast.success(res.message || "Job cancelled successfully");
        if (onRefresh) onRefresh();
      } else {
        toast.error(res.message || "Failed to cancel job");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error cancelling job");
    }
  };

  const handleCancelClose = () => {
    setShowCancelModal(false);
  };

  console.log(job, "=============job==========")
  return (
    <div className="table-responsive">
      <div style={{ minWidth: 850 }}>
        {/* ---------- Header ---------- */}
        {job?.status === "Cancelled" && (
          <Card className="text-center mt-3">
            <Card.Header className="text-danger fw-bold fs-5 mb-4">
              Reason For Cancelled Job:&nbsp;
              <strong>
                {job?.cancellationReason?.en || "Reason Not Found"} (
                {job?.cancellationReason?.hi || "कारण नहीं मिला"})
              </strong>
            </Card.Header>
          </Card>
        )}

        {job?.status === "Paused" && (
          <Card className="text-center mt-3">
            <Card.Header className="text-primary fw-bold fs-5 mb-4">
              Reason For Pause Job:&nbsp;
              <strong>
                {job?.pausedReason?.en || "Reason Not Found"} (
                {job?.pausedReason?.hi || "कारण नहीं मिला"})
              </strong>
            </Card.Header>
          </Card>
        )}

        <Card className="mb-4">
          <Card.Body className="d-flex align-items-center">
            <h5 className="me-3 mb-0">
              {getBilingualText(job, "equipment") || "—"}
            </h5>
            <Badge
              bg={JOB_STATUS_COLORS[job.status]?.startsWith("#") ? "" : (JOB_STATUS_COLORS[job.status] || "secondary")}
              style={JOB_STATUS_COLORS[job.status]?.startsWith("#") ? { backgroundColor: JOB_STATUS_COLORS[job.status] } : {}}
              className="me-2"
            >
              {job.status || "—"}
            </Badge>
            {(job.status === "Pending" || job.status === "No Show" || job.status === "No-show" || job.status === "no-show") && (
              <Button
                variant="danger"
                size="sm"
                className="ms-auto"
                onClick={handleCancelClick}
              >
                Cancel Job
              </Button>
            )}
            {/* {extensionRequested && (
              <Badge bg="warning" className="me-2">
                Extension Requested
              </Badge>
            )} */}
            <span className="text-muted ms-3">
              <FaMapMarkerAlt className="me-1" />
              {displayAddress(job.address) ||
                displayAddress(customer.address) ||
                "—"}
            </span>
          </Card.Body>
        </Card>

        {/* ---------- Rental/Payment Summary ---------- */}
        <Row className="g-3 mb-4">
          {[
            {
              label: "Rental Type",
              value: `${job.unit === "Area" ? "Area" : job.unit === "ft" ? "Ft" : "Hour"
                } , Delivery Charge Per KM ₹${Number(
                  job.deliveryCharge || 0
                ).toLocaleString()}`,
            },
            {
              label: "Job Price",
              value: `₹${job.price ? job.price?.toFixed(2).toLocaleString() : 0
                }`,
            },
            {
              label: "Customer Payout",
              // value:
              //   commissionType === "percent"
              //     ? `${commissionValue || 0}%`
              //     : `₹${commissionValue || 0}`,
              value: job?.customerPayout?.toFixed(2) ?? 0,
            },
            {
              label: "Vendor Payout",
              value: `₹${job?.vendorPayout?.toFixed(2) ?? 0}`,
            },
          ].map((item, idx) => (
            <Col key={idx} md={3}>
              <Card className="h-100 bg-light border-0">
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-muted">
                    {item.label}
                  </Card.Subtitle>
                  <Card.Title className="mb-1">{item.value}</Card.Title>
                  {item.sub && (
                    <Card.Text className="text-muted small">
                      {item.sub}
                    </Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* ---------- Tabs ---------- */}
        <Tabs defaultActiveKey="summary" className="mb-3">
          {/* Summary Tab */}
          <Tab
            eventKey="summary"
            title={
              <>
                <FaInfoCircle className="me-1" />
                Summary
              </>
            }
          >
            <Card>
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <table className="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th>Created At:</th>
                          <td>{makeDateTimeString(job?.createdAt)}</td>
                        </tr>
                        <tr>
                          <th>Scheduled Date & Time:</th>
                          <td>{job?.jobDateTime}</td>
                        </tr>
                        <tr>
                          <th>Assigned On:</th>
                          <td>{assignedAt}</td>
                        </tr>
                        <tr>
                          <th>Started On:</th>
                          <td>
                            {makeDateTimeString(jobStartDateTime) ||
                              "Not Started"}
                          </td>
                        </tr>
                        <tr>
                          <th>Pause Time:</th>
                          <td>
                            {makeDateTimeString(job?.jobPausedTime) ||
                              "Not Available"}
                          </td>
                        </tr>
                        <tr>
                          <th>Extension Request Start:</th>
                          <td>
                            {makeDateTimeString(
                              job?.extensionrequestStartDateTime
                            ) || "Not Available"}
                          </td>
                        </tr>
                        <tr>
                          <th>Extension Start:</th>
                          <td>
                            {makeDateTimeString(job?.extensionStartDateTime) ||
                              "Not Available"}
                          </td>
                        </tr>
                        <tr>
                          <th>Extension End:</th>
                          {/* <td> */}
                          {/* {makeDateTimeString(job?.extensionEndDateTime)
                              ? makeDateTimeString(job.extensionEndDateTime)
                              : job?.status === "Complete" && job?.endedAt
                              ? makeDateTimeString(job.endedAt)
                              : "Not Available"} */}
                          <td>
                            {makeDateTimeString(job?.extensionEndDateTime) ||
                              "Not Available"}
                          </td>
                          {/* </td> */}
                        </tr>
                        {job?.extensions?.find(
                          (e) => e.status === "rejected"
                        ) && (
                            <tr>
                              <th>Extension Rejected:</th>
                              <td>
                                {makeDateTimeString(
                                  job.extensions.find(
                                    (e) => e.status === "rejected"
                                  ).rejectedAt ||
                                  job.extensions.find(
                                    (e) => e.status === "rejected"
                                  ).updatedAt
                                )}
                              </td>
                            </tr>
                          )}
                        <tr>
                          <th>Completed On:</th>
                          <td>
                            {job?.status === "Complete" && jobEndDateTime ? (
                              makeDateTimeString(jobEndDateTime)
                            ) : (
                              <em>Not completed yet</em>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Description:</th>
                          <td>{job?.descriptionEn || job?.description?.en || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                  <Col md={6}>
                    <table className="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th>
                            Rental Basis:{" "}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="hour-used-tooltip">
                                  Equipment Price is ₹
                                  {job?.equipmentDetails?.equipmentPrice || 0}
                                </Tooltip>
                              }
                            >
                              <span
                                style={{ cursor: "pointer", color: "#0d6efd" }}
                              >
                                <FaInfoCircle size={14} />
                              </span>
                            </OverlayTrigger>
                          </th>
                          <td>
                            {job?.areaTimeValue || 0}{" "}
                            {job?.areaTimeType === "Area"
                              ? "Area"
                              : job?.areaTimeType === "ft"
                                ? "ft"
                                : "Hour"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            Hour Used:{" "}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="hour-used-tooltip">
                                  Hours are calculated automatically when the
                                  job is completed
                                </Tooltip>
                              }
                            >
                              <span
                                style={{ cursor: "pointer", color: "#0d6efd" }}
                              >
                                <FaInfoCircle size={14} />
                              </span>
                            </OverlayTrigger>
                          </th>
                          <td>{job?.hourUsed || 0}</td>
                        </tr>
                        {/* <tr>
                          <th>Amount:</th>
                          <td>
                            ₹
                            {(
                              Number(job?.price || 0) -
                              Number(job?.commissionAmount || 0)
                            ).toFixed(2)}
                          </td>
                        </tr> */}
                        {/* <tr>
                          <th>Commission:</th>
                          <td>
                            {Number(job?.commissionAmount || 0).toFixed(2)}
                          </td>
                        </tr> */}

                        <tr>
                          <th>
                            Distance:{" "}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="hour-used-tooltip">
                                  Distance Per Km ₹
                                  {job?.equipmentDetails
                                    ?.equipmentDilveryCharge || 0}
                                </Tooltip>
                              }
                            >
                              <span
                                style={{ cursor: "pointer", color: "#0d6efd" }}
                              >
                                <FaInfoCircle size={14} />
                              </span>
                            </OverlayTrigger>
                          </th>
                          <td>{job?.distance}km</td>
                        </tr>
                        {/* <tr>
                          <th>Delivery Charge After Accepting job</th>
                          <td>
                            ₹{Number(job?.finalDeliveryCharge || 0).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <th>Cutomer Payout:</th>
                          <td>
                            ₹{Number(job?.customerPayout || 0).toFixed(2)}
                          </td>
                        </tr> */}
                        <tr>
                          <th>Payment Status:</th>
                          <td>
                            <Badge bg={paymentStatusVariant}>
                              {job.paymentStatus || "—"}
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <th>Review:</th>
                          <td>
                            <Badge bg={reviewStatusVariant}>
                              {job.reviewStatus || "—"}
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Tab>

          {/* Participants Tab */}
          <Tab
            eventKey="participants"
            title={
              <>
                <FaUsers className="me-1" />
                Participants
              </>
            }
          >
            <Row className="mt-3 g-3">
              <Col md={6}>
                <Card>
                  <Card.Header>
                    <strong>Customer</strong>
                  </Card.Header>
                  <Card.Body>
                    <p>
                      <strong>Name:</strong>{" "}
                      {getBilingualText(customer, "name") || "—"}
                    </p>
                    <p>
                      <strong>Location:</strong>{" "}
                      {displayAddress(job?.address) || "—"}
                    </p>
                    <p>
                      <FaPhone className="me-1" />
                      <a href={`tel:${customer.phone || ""}`}>
                        {customer.phone || "—"}
                      </a>
                    </p>
                    <p>
                      <FaEnvelope className="me-1" />
                      <a href={`mailto:${customer.email || ""}`}>
                        {customer.email || "—"}
                      </a>
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card>
                  <Card.Header>
                    <strong>Vendor / Driver</strong>
                  </Card.Header>
                  <Card.Body>
                    <p>
                      <strong>Name:</strong>{" "}
                      {getBilingualText(vendor, "name") || "—"}
                    </p>
                    <p>
                      <strong>Location:</strong> {vendor.location || "—"}
                    </p>
                    <p>
                      <FaPhone className="me-1" />
                      <a href={`tel:${vendor.phone || ""}`}>
                        {vendor.phone || "—"}
                      </a>
                    </p>
                    <p>
                      <FaEnvelope className="me-1" />
                      <a href={`mailto:${vendor.email || ""}`}>
                        {vendor.email || "—"}
                      </a>
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab>

          <Tab
            eventKey="timeline"
            title={
              <>
                <FaRegClock className="me-1" />
                Timeline
              </>
            }
          >
            <Timeline events={events} useSimpleList={true} />
          </Tab>

          <Tab
            eventKey="photos"
            title={
              <>
                <FaImages className="me-1" />
                Photos
              </>
            }
          >
            <Card className="mt-3">
              <Card.Body>
                {job?.photos && job.photos.length > 0 ? (
                  <Row className="g-3">
                    {job.photos.map((url, idx) => (
                      <Col key={idx} xs={12} sm={6} md={4} lg={3}>
                        <div
                          className="border rounded overflow-hidden shadow-sm"
                          style={{ height: "200px" }}
                        >
                          <a href={url} target="_blank" rel="noopener noreferrer">
                            <img
                              src={url}
                              alt={`Job photo ${idx + 1}`}
                              className="w-100 h-100 object-fit-cover"
                              style={{ objectFit: "cover" }}
                            />
                          </a>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="text-center text-muted py-5">
                    <FaImages size={48} className="mb-3 opacity-25" />
                    <p>No photos available for this job.</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Tab>

          <Tab
            eventKey="map"
            title={
              <>
                <FaMapMarkerAlt className="me-1" /> Map
              </>
            }
          >
            <div
              className="mt-3"
              style={{ width: "100%", height: 400, position: "relative" }}
            >
              {job?.location?.latitude && job?.location?.longitude ? (
                <>
                  <iframe
                    title="Job Location"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                    loading="lazy"
                    allowFullScreen
                    // src={`https://www.google.com/maps?q=${encodeURIComponent(
                    //   displayMap(job.address)
                    // )}&z=15&output=embed`}
                    src={`https://www.google.com/maps?q=${job?.location?.latitude},${job?.location?.longitude}&z=17&output=embed`}
                  />
                  <div className="p-2 bg-light text-center small text-muted border-top">
                    {displayMap(job.address)}
                  </div>
                </>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100 text-muted bg-light">
                  <p>No address available</p>
                </div>
              )}
            </div>
          </Tab>

          {/* Payments */}
          {/* <Tab
            eventKey="payments"
            title={
              <>
                <FaCreditCard className="me-1" />
                Payments
              </>
            }
          >
            <Card className="mt-3">
              <Card.Body>
                <table
                  className="table table-borderless mb-0"
                  style={{ maxWidth: 500 }}
                >
                  <tbody>
                    <tr>
                      <th>Quote</th>
                      <td>
                        ₹
                        {Number(
                          Number(job?.price || 0).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <th>Vendor Distance (km)</th>
                      <td>{job.distance ? `${job.distance} km` : "0 km"}</td>
                    </tr>
                    <tr>
                      <th>Delivery Charge Per Km</th>
                      <td>
                        ₹
                        {Number(
                          Number(job?.deliveryCharge || 0).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <th>Final Delivery Charge</th>
                      <td>
                        ₹
                        {Number(
                          Number(job?.finalDeliveryCharge || 0).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <th>Commission Amount</th>
                      <td>
                        ₹
                        {Number(
                          Number(job?.commissionAmount || 0).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <th>Total netQuote(Quote - Commission)</th>
                      <td>
                        ₹
                        {(() => {
                          const quote = Number(job.price || 0);

                          let commission = 0;

                          if (commissionType === "percent") {
                            commission = (quote * commissionValue) / 100;
                          } else {
                            commission = Number(commissionValue);
                          }

                          const netQuote = quote - commission;
                          return Number(netQuote.toFixed(2)).toLocaleString(
                            "en-IN"
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>Payout to Vendor(netQuote+ finalDeliveryCharge)</th>
                      <td>
                        ₹
                        {Number(job?.vendorPayout || 0)
                          .toFixed(2)
                          .toLocaleString?.("en-IN")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          </Tab> */}
          <Tab
            eventKey="payments"
            title={
              <>
                <FaCreditCard className="me-1" />
                Payments
              </>
            }
          >
            <Row className="mt-3 g-3">
              <Col md={6}>
                <Card>
                  <Card.Header>
                    <strong>Vendor Payout</strong>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>Job Price </strong>{" "}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="delivery-charge-tooltip">
                              Equipment Price is ₹
                              {job?.equipmentDetails?.equipmentPrice}
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              marginLeft: 6,
                            }}
                          >
                            <FaInfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                      </span>
                      <span>
                        ₹
                        {Number(job?.price || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>Delivery Charge</strong>{" "}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="delivery-charge-tooltip">
                              Delivery charge is calculated as per distance
                              traveled {job?.distance} × ₹
                              {job?.equipmentDetails?.equipmentDilveryCharge}.
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              marginLeft: 6,
                            }}
                          >
                            <FaInfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                      </span>

                      <span>
                        ₹
                        {Number(job?.finalDeliveryCharge || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>Commission Amount</strong>
                      </span>
                      <span>
                        ₹
                        {Number(job?.commissionAmount || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>
                          Total Net Quote (Job Price − Commission)
                        </strong>
                      </span>
                      <span>
                        ₹
                        {(() => {
                          const quote = Number(job.price || 0);
                          let commission = 0;

                          if (commissionType === "percent") {
                            commission = (quote * commissionValue) / 100;
                          } else {
                            commission = Number(commissionValue);
                          }

                          return Number(
                            (quote - commission).toFixed(2)
                          ).toLocaleString("en-IN");
                        })()}
                      </span>
                    </div>
                    {job?.walletDiscountAmount !== 0 && (
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          <strong>Vendor Refferal Discount</strong>
                        </span>
                        <span>₹ {job?.walletDiscountAmount}</span>
                      </div>
                    )}
                    {/* TDS – only if not 0 */}
                    {Number(job?.tds || 0) !== 0 && (
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          <strong>TDS</strong>
                        </span>
                        <span>
                          ₹
                          {Number(job?.tds || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}

                    {/* CGST – only if not 0 */}
                    {Number(job?.cgst || 0) !== 0 && (
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          <strong>CGST</strong>
                        </span>
                        <span>
                          ₹
                          {Number(job?.cgst || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}

                    {/* SGST – only if not 0 */}
                    {Number(job?.sgst || 0) !== 0 && (
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          <strong>SGST</strong>
                        </span>
                        <span>
                          ₹
                          {Number(job?.sgst || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}
                    <hr />

                    <div className="d-flex justify-content-between">
                      <span>
                        <strong>Payout to Vendor</strong>
                      </span>
                      <span className="fw-bold">
                        ₹
                        {Number(job?.vendorPayout || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card>
                  <Card.Header>
                    <strong>Customer Payout</strong>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>Job Price </strong>{" "}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="delivery-charge-tooltip">
                              Equipment Price is ₹
                              {job?.equipmentDetails?.equipmentPrice}
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              marginLeft: 6,
                            }}
                          >
                            <FaInfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                      </span>
                      <span>
                        ₹
                        {Number(job?.price || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>
                        <strong>Delivery Charge</strong>{" "}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="delivery-charge-tooltip">
                              Delivery charge is calculated as per distance
                              traveled {job?.distance} × ₹
                              {job?.equipmentDetails?.equipmentDilveryCharge}.
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              marginLeft: 6,
                            }}
                          >
                            <FaInfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                      </span>

                      <span>
                        ₹
                        {Number(job?.finalDeliveryCharge || 0)
                          .toFixed(2)
                          .toLocaleString("en-IN")}
                      </span>
                    </div>

                    {job?.referralApplied == true && (
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          <strong>Refferal Discount</strong>
                        </span>
                        <span>
                          ₹
                          {Number(job?.referralDiscount || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}
                    <hr />

                    <div className="d-flex justify-content-between">
                      <span>
                        <strong>Payout to Customer</strong>
                      </span>
                      <span className="fw-bold">
                        ₹{Number(job?.customerPayout || 0).toFixed(2)}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab>

          {/* Reviews */}
          <Tab
            eventKey="reviews"
            title={
              <>
                <FaCommentDots className="me-1" />
                Reviews
              </>
            }
          >
            <Card className="mt-3">
              <Card.Body>
                <div>
                  <strong>Customer:</strong>{" "}
                  {getBilingualText(customer, "name") || "—"}
                </div>
                <p className="text-muted">
                  Review: {job.customerReview || "No review yet."}
                </p>
                <hr />
                <div>
                  <strong>Vendor:</strong>{" "}
                  {getBilingualText(vendor, "name") || "—"}
                </div>
                <p className="text-muted">
                  Review: {job.vendorReview || "No review yet."}
                </p>
              </Card.Body>
            </Card>
          </Tab>

          {/* Audit */}
          <Tab
            eventKey="audit"
            title={
              <>
                <FaHistory className="me-1" /> Audit Log
              </>
            }
          >
            <Card className="mt-3 w-100">
              <Card.Body className="p-0">
                {Array.isArray(job.rawData?.paymentDetails) &&
                  job.rawData.paymentDetails.length > 0 ? (
                  <div className="w-100" style={{ maxWidth: "100%" }}>
                    <Row className="fw-bold border-bottom py-2 text-center bg-light w-100 m-0">
                      <Col xs={12} className="fs-5">
                        Payment Audit Details
                      </Col>
                    </Row>

                    <Row className="w-100 m-0">
                      {[0, 1].map((colIndex) => {
                        const half = Math.ceil(
                          job.rawData.paymentDetails.length / 2
                        );
                        const start = colIndex * half;
                        const end = start + half;
                        const halfData = job.rawData.paymentDetails.slice(
                          start,
                          end
                        );

                        return (
                          <Col
                            xs={12}
                            md={6}
                            key={colIndex}
                            style={{ width: "100%" }}
                          >
                            {halfData.map((item, index) => {
                              const createdAt = parseDateFlexible(
                                item.createdAt
                              );
                              const formattedDate = createdAt
                                ? createdAt.toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                  hour12: true,
                                  hour: "numeric",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                : "—";

                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    borderBottom: "1px solid #eee",
                                    padding: "10px 15px",
                                  }}
                                >
                                  <p className="mb-1 fs-6">
                                    <strong>Customer:</strong>{" "}
                                    {getBilingualText(
                                      job.rawData.customer,
                                      "name"
                                    ) || "—"}
                                  </p>
                                  <p className="mb-1 fs-6">
                                    <strong>Job ID:</strong> {item.jobId || "—"}
                                  </p>
                                  <p className="mb-1 fs-6">
                                    <strong>Order ID:</strong>{" "}
                                    {item.razorpayOrderId || "—"}
                                  </p>
                                  <p className="mb-1 fs-6">
                                    <strong>Amount:</strong> ₹{item.amount}
                                  </p>
                                  <p className="mb-1 fs-6">
                                    <strong>Status:</strong>{" "}
                                    <Badge
                                      bg={
                                        item.status === "Success"
                                          ? "success"
                                          : "danger"
                                      }
                                    >
                                      {item.status}
                                    </Badge>
                                  </p>
                                  <p className="mb-0 fs-6">
                                    <strong>Created At:</strong> {formattedDate}
                                  </p>
                                </div>
                              );
                            })}
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                ) : (
                  <div className="text-center text-muted py-3 fs-6">
                    No payment records found.
                  </div>
                )}
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>
      </div>

      <Modal show={showCancelModal} onHide={handleCancelClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to cancel this job? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleCancelConfirm}>
            Confirm Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
